import { AccessTimeFilledIcon, CalendarTodayIcon } from "@l2r-front/l2r-icons"

import { EVENT_INFOS_DATE, EVENT_INFOS_HOURS } from "./event"

export const timeIcons = {
    [EVENT_INFOS_DATE]: CalendarTodayIcon,
    [EVENT_INFOS_HOURS]: AccessTimeFilledIcon,
}